// extracted by mini-css-extract-plugin
export default {"container":"VoterMyCandidacy_container__FkOrq","header":"VoterMyCandidacy_header__-UC3z"};